export default "__VITE_ASSET__e8394d3c__"